import SiteApp from "@/site/App";

export default function App() {
    return <SiteApp />;
}
